const SiteInfoTypes = {
    SET_SITE_INFO: 'SET_SITE_INFO'
}

export default SiteInfoTypes;